import { WORKSPACE_LIST_PAGE } from "@/lib/constants/workspace-layout";
import { cn } from "@/lib/utils";

export const LIST_FILTER_TOOLBAR =
  "mt-2 flex min-w-0 max-w-full flex-col gap-2 overflow-x-clip md:flex-row md:flex-nowrap md:items-center md:gap-1";

export const LIST_FILTER_ROW =
  "flex min-w-0 max-w-full flex-col gap-2 overflow-x-clip md:flex-row md:flex-nowrap md:items-center md:gap-1";

export const LIST_FILTER_SEARCH =
  "relative min-w-0 w-full md:min-w-[12rem] md:flex-1";

export const LIST_FILTER_CONTROLS = cn(
  WORKSPACE_LIST_PAGE.FILTER_ROW,
  "py-0 md:flex-nowrap md:overflow-visible md:snap-none",
);

export const IAM_LIST_FILTER_ROW = "flex w-full min-w-0 items-center gap-1.5";
export const IAM_LIST_FILTER_PRIMARY = "grid min-w-0 flex-1 grid-cols-1 items-center gap-1.5";
export const IAM_LIST_FILTER_SELECT = "!h-8 !min-h-8";

export const LIST_FILTER_ACTIONS = "flex shrink-0 items-center gap-1";

/** List toolbar create/import/refresh openers — icon only; label via aria-label. */
export const LIST_FILTER_ICON_BUTTON = "h-8 w-8 shrink-0 px-0";

/** List/detail row icon actions (edit/delete/secondary) — icon only; label via aria-label. */
export const LIST_ROW_ICON_BUTTON = "h-7 w-7 shrink-0 px-0";

/** List row workflow text verbs (submit/approve/reject/evaluate/lock) — full i18n label. */
export const LIST_ROW_TEXT_BUTTON = "h-7 shrink-0 px-2 text-xs";

export const LIST_FILTER_SECTION = WORKSPACE_LIST_PAGE.FILTER_SECTION;

export const LIST_FILTER_ROW_FILTER_CLASS = "min-w-0 md:flex md:flex-none";

export const LIST_FILTER_CHIP =
  "h-7 shrink-0 snap-start rounded-full px-3 text-xs md:shrink md:snap-align-none";

export const LIST_FILTER_FIELD_INPUT = "h-8 w-full min-w-0 flex-1 text-xs";

/** Width shell for list filters — apply only via `ListToolbarSelect`, not raw SearchableSelect. */
export const LIST_FILTER_FIELD_SELECT = "min-w-[9rem] shrink-0 snap-start";

export const LIST_FILTER_DATE_FIELD = "h-8 w-full min-w-0 shrink-0 text-xs sm:w-[8.5rem]";

export const LIST_FILTER_EDITOR_ROW =
  "flex min-w-0 max-w-full flex-col gap-2 overflow-x-clip border-b border-border pb-2 md:flex-row md:items-center md:gap-1";

export const LIST_FILTER_EDITOR_SEARCH = "relative min-w-0 w-full md:min-w-[14rem] md:flex-1";

export const LIST_FILTER_COMPACT_INPUT =
  "h-8 w-full min-w-0 shrink-0 snap-start text-xs placeholder:text-muted-foreground/60 placeholder:italic sm:w-[8rem]";
